import Logger from '@common/Logger';

export function throwError(err: any, message = 'Something went wrong', payload: any = { err }) {
  Logger.error(message, { payload });
  const error = new Error(err) as any;
  error.response = err?.response;
  throw error;
}
